import demoApi from "../../../api/e-loket/demoApi";
import { formatFilesForSave } from "../../../components/common/FilesHelperUtil";
import redirector from "../../../util/redirector";

import * as messages from "../../../constants/ToastrConstants";
import { showToastrError } from "../../../util/toastr";

import assign from 'object-assign';

export default class DemoPageHelper {

    constructor(context, redirector) {
        this.context = context;
        this.redirector = redirector;
    }

    init() {
        const context = this.context;
        const ajaxActions = context.props.ajaxActions;

        const params = context.props.match.params;
        const modelId = params.modelId;
        const isEdit = params.isEdit || false;
        const isNew = context.props.isNew;

        const returnUrl = decodeURIComponent(context.props.match.params.returnUrl);

        ajaxActions.started();
        if (modelId && !isNew) {
            demoApi.get(modelId)
                .then((response) => {
                    ajaxActions.ended();
                    this.processModel(response, false);
                })
                .catch((ex) => {
                    ajaxActions.failed();
                    context.props.throwException(ex);
                });
        }
        else if (isNew) {
            demoApi.getEmpty()
                .then((response) => {
                    ajaxActions.ended();
                    this.processModel(response, true);
                })
                .catch((ex) => {
                    ajaxActions.failed();
                    context.props.throwException(ex);
                });
        }

        context.setState({
            modelId,
            isEdit,
            isNew,
            returnUrl
        });
    }

    save() {
        const context = this.context;
        const ajaxActions = context.props.ajaxActions;

        context.filesHelper.commitSession();

        let errors = null;
        let model = null;

        let modelToSave = this.context.state.model;

        //todo rework documentsModel server side to avoid this
        let fileBaseUrl = this.context.filesHelper.getBaseFileLocation();
        let documentsForSave = formatFilesForSave(context.state.fileComponents, fileBaseUrl);

        ajaxActions.started();
        return demoApi.save(modelToSave, documentsForSave).then((response) => {
            ajaxActions.ended();
            if (response.statusText === "OK" && !response.data.hasValidationErrors) {
                if (Object.keys(response.data.validationResults).length !== 0) {
                    model = assign({}, response.data.item);
                    errors = assign({}, response.data.validationResults);
                }
                else {
                    model = assign({}, response.data.item, {});
                    errors = {};
                }

                context.setState({
                    hasUnsavedChanges: false
                });
            } else {
                errors = assign({}, response.data.validationResults);
                model = assign({}, response.data.item, {});
                showToastrError(messages.MESSAGE_VALIDATION_ERRORS);
            }

            this.context.setState({
                errors: errors,
                model
            });
        })
            .catch((ex) => {
                ajaxActions.failed();
                context.props.throwException(ex);
            });
    }

    processModel(response, isNew) {
        const context = this.context;
        let model = isNew ? response.data : response.data.item;

        let validationResults = isNew ? null : response.data.validationResults;

        if (!model.children)
            model = assign({}, model, { children: [{ name: "TheFirstChild" }] });

        context.setState({
            model,
            errors: validationResults
        });
        // }, () => this.doStuff()); // example of a callback on the setState

        context.props.loadLayout(model.title, isNew, model.id);
    }

    change(event) {
        const value = event.target.value;
        const property = event.target.name;

        const model = this.context.state.model;
        model[property] = value;

        this.context.setState({
            model,
            hasUnsavedChanges: true
        });
    }

    close() {
        const returnUrl = this.context.state.returnUrl;
        redirector.goToPathInParentWindow(returnUrl);
    }
}